<template>
  <b-modal
    :id="modalId"
    :title="$translate(title)"
    hide-footer
    size="lg"
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
    @hide="hide"
  >
    <div class="row">
      <div
        v-for="({ type, value }) in structureList"
        :key="value"
        class="col-12 col-lg-12 col-sm-12 col-xs-12"
      >
        <Select
          v-if="type === DYNAMIC_DATA_TYPES.BOOLEAN"
          v-model="data[value]"
          :options="[{ value: 'true', text: 'True' }, { value: 'false', text: 'False' }]"
          :form-group-id="value"
          :placeholder="value"
          required
        />
        <Input
          v-else
          v-model="data[value]"
          :type="type === DYNAMIC_DATA_TYPES.NUMBER ? 'number' : 'text'"
          :form-group-id="value"
          :placeholder="value"
          required
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between mt-3">
        <b-button
          variant="outline-secondary"
          size="lg"
          class="btn-delete-device mr-3 px-140"
          @click="close"
        >
          {{ 'Close' | i18n }}
        </b-button>
        <b-button
          variant="outline-primary"
          size="lg"
          class="btn-delete-device px-140"
          :disabled="!structureList.every(({ value }) => data[value])"
          @click="onSubmit"
        >
          {{ 'Save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Input from '../../common/input';
import Select from '../../common/select';
import { NotificationMixin } from '../../../../mixins';
import { DYNAMIC_DATA_TYPES } from '../../../../../../../constants';
import api from '../../../api';

export default {
  title: 'Content item details',
  components: { Input, Select },
  mixins: [NotificationMixin],
  props: {
    getPage: {
      type: Function,
      default: () => {}
    },
    modalId: {
      type: String,
      default: ''
    },
    structureId: {
      type: String,
      default: ''
    },
    structureList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    selectedItemId: {
      type: String,
      default: () => {}
    },
    modalType: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      DYNAMIC_DATA_TYPES,
      data: {},
      preventCloseLocal: true,
    };
  },
  methods: {
    async show() {
      this.clear();
      if (this.modalType === 'edit') {
        const response = await api.dynamicData.getContentItemById(this.selectedItemId);
        const data = {};
        Object.keys(response.data).forEach((key) => {
          data[key] = typeof response.data[key] == 'boolean' ? response.data[key].toString() : response.data[key];
        });
        this.data = data;
      }
    },
    close() {
      this.$root.$emit('bv::hide::modal', this.modalId);
      this.clear();
    },
    clear() {
      this.data = {};
    },
    hide(e) {
      if (this.preventCloseLocal) {
        let message = confirm(this.$translate('You have not saved your progress Are you sure you want to leave this page'));
        if (!message) {
          e.preventDefault();
        }
        this.clear();
      }
    },
    async onSubmit() {
      try {
        this.preventCloseLocal = false;
        const data = {};
        Object.keys(this.data).forEach((key) => {
          data[key] = this.data[key] === 'false' ? false : this.data[key];
        });
        const payload = {
          structureId: this.structureId,
          data,
        };

        if (this.modalType === 'edit') {
          await api.dynamicData.updateContentItem(this.selectedItemId, payload);
        } else {
          await api.dynamicData.createContentItem(payload);
        }
        this.$root.$emit('bv::hide::modal', this.modalId);
        await this.getPage();
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
        this.preventCloseLocal = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}
.px-140 {
  padding-left: 140px;
  padding-right: 140px;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
